// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__zg7rH","pl1g":"Spinner_pl1g__vFH9+","pl1rect":"Spinner_pl1rect__9tVBS","pl1a":"Spinner_pl1a__lXTfv","pl1b":"Spinner_pl1b__BTecm","pl1c":"Spinner_pl1c__cW9rX"};